<template>
    <div>
      <Form ref="myForm" :label-width="110">
        <FormItem label="通讯录标题" prop="title">
          <Input type="text" v-model="rowData.title"  readonly></Input>
        </FormItem>
        <FormItem label="子标题" prop="son_title">
          <Input type="text" v-model="rowData.son_title" readonly></Input>
        </FormItem>
        <FormItem label="选择群主" >
          <Input type="text" v-model="rowData.member_id"  readonly></Input>
        </FormItem>
        <FormItem label="通讯录图" prop="picture">
          <div class="demo-upload-list">
            <img :src="rowData.picture">
            <div class="demo-upload-list-cover">
              <Icon type="ios-eye-outline" @click.native="handleView(rowData.picture)"></Icon>
            </div>
          </div>
        </FormItem>
        <FormItem label="详情页图">
          <div class="demo-upload-list">
            <img :src="rowData.detail_picture">
            <div class="demo-upload-list-cover">
              <Icon type="ios-eye-outline" @click.native="handleView(rowData.detail_picture)"></Icon>
            </div>
          </div>
        </FormItem>
        <FormItem label="查看人次" >
          <InputNumber type="text" v-model="rowData.see_number" readonly></InputNumber>
        </FormItem>
        <FormItem label="加入金额" >
          <InputNumber type="text" v-model="rowData.join_price" readonly></InputNumber>
        </FormItem>
        <FormItem label="内容" prop="content">
          <tinymce ref="basic_info" :height="300" v-model="rowData.content" @input="rowData.content = $event" disabled></tinymce>
        </FormItem>
      </Form>
      <Modal title="大图预览" v-model="imageVisible">
        <img :src="imageName" v-if="imageVisible" style="width: 100%">
      </Modal>
    </div>
</template>

<script>
import tinymce from '../../../components/tinymce/index'

export default {
  name: 'detail',
  components: { tinymce },
  props: {
    rowData: {
      type: Object
    }
  },
  data () {
    return {
      formItem: {
        title: '',
        son_title: '',
        picture: '',
        detail_picture: '',
        see_number: 0,
        content: '',
        member_id: ''
      },
      imageVisible: false,
      imageName: ''
    }
  },
  methods: {
    handleView (name) {
      this.imageName = name
      this.imageVisible = true
    }
  }
}
</script>

<style scoped>
  /deep/ .ql-editor {
    height: 150px;
  }

  .demo-upload-list{
    display: inline-block;
    width: 90px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
